// src/hooks/useMutationQueueStatus.js
//
// Tiny hook exposing the mutation queue's pending + failed counts. Updates
// on every queue change (via the mutation-queue-change window event fired
// by main.jsx's initMutationQueue onChange hook). Components use this to
// render a "N syncing" / "N failed" indicator.

import { useState, useEffect, useCallback } from 'react'
import { getPendingCount, getFailedCount } from '../lib/mutationQueue'

export function useMutationQueueStatus() {
  const [state, setState] = useState({ pending: 0, failed: 0 })

  const refresh = useCallback(async () => {
    try {
      const [pending, failed] = await Promise.all([getPendingCount(), getFailedCount()])
      setState({ pending, failed })
    } catch {
      // Non-fatal — leave state as-is
    }
  }, [])

  useEffect(() => {
    refresh()
    const onChange = () => refresh()
    window.addEventListener('mutation-queue-change', onChange)
    window.addEventListener('focus', onChange)
    return () => {
      window.removeEventListener('mutation-queue-change', onChange)
      window.removeEventListener('focus', onChange)
    }
  }, [refresh])

  return state
}
